module.exports = __webpack_public_path__ + "static/img/jd.42fefb3b.svg";